<template>
  <div>
    <login-component />
  </div>
</template>

<script>
import LoginComponent from "@/components/LoginComponent.vue";
export default {
  name: "LoginPage",
  components: { LoginComponent },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  mounted() {
    if (this.isLoggedIn) {
      this.$router.push('/')
    }
  },
};
</script>

<style scoped>
</style>

